import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {ListWrapper} from './news-list/List'

const documentsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Gerenciamento de Notícias',
    path: '/apps/news-management/news',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const NewsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='news'
          element={
            <>
              <PageTitle breadcrumbs={documentsBreadcrumbs}>Lista de Notícias</PageTitle>
              <ListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/news-management/news' />} />
    </Routes>
  )
}

export default NewsPage
